import RD from "@/api/RD";
export default {
    store: {
        webName: "中国县市图片-昭觉网",
        count: 1,
        addrTree: [],
        typeTree: [],
        userInfo: {},
        logined: false,
        navClass: false
    },

    /**
     * in this method, this is the basicFrame, vue component
     */
    initExtra() {
        console.log("init extra run");
        let thiz = this;
        var prefixURL = "https://www.chinaphotos.cn/client/v_0.1";
        // var prefixURL = "http://192.168.3.50:82/client/v_0.1";

        RD.setPreFix(prefixURL);
        RD.setErrorHandler(function (error) {
            console.log(error);
            return new Promise((resolve, reject) => {
                if (error.code && error.code < 10) {
                    thiz.$message(error.msg);
                    thiz.$rtm.hideLoading();
                    resolve();
                } else {
                    reject();
                }
            });
        });
        RD.setLoadingStartAction(function () {
            thiz.$rtm.showLoading();
        });
        RD.setLoadingEndAction(function () {
            thiz.$rtm.hideLoading();
        });
    }
};
